import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DismantlingBayType } from "../models/DismantlingBay";
import { IProductionDashboardOverviewResponse } from "../models/ProductionDashboard";

export default function useProductionDashboardOverview(type: DismantlingBayType) {
  const { get } = useApiHelper();

  const overview = useQuery({
    queryKey: ["production-dashboard-overview", type],
    queryFn: () =>
      get<IProductionDashboardOverviewResponse>(`/productionmanager/overview?type=${type}`),
    staleTime: 1000 * 15,
    refetchInterval: 1000 * 30,
  });

  return { overview };
}
